import { Box, Grid, Image, Typography } from '@hermes/web-components'
import React from 'react'
import { PATH_TO_UNAVAILABLE_IMG } from '../../../constants/global'
import { ContentWrapper, VideoWrapper, SubVideoWrapper } from './styles'
import NextImage from 'next/image'
import { doctifyCDNLoader } from '../../../utils/imageLoaders'

type ReviewVideoProps = {
  image: string
  practitioner?: string
  title: string
  onClick: () => void
}

const ReviewVideo = ({ image, practitioner, title, onClick }: ReviewVideoProps) => (
  <VideoWrapper onClick={onClick}>
    <NextImage
      src={image || PATH_TO_UNAVAILABLE_IMG}
      layout="fill"
      style={{
        position: 'absolute',
        objectFit: 'cover',
        zIndex: 0
      }}
      loading="lazy"
      alt={title || ''}
      loader={doctifyCDNLoader}
    />
    <SubVideoWrapper
      container
      position="absolute"
      zIndex={1}
      justifyContent="space-between"
      flexDirection="column"
      wrap="nowrap"
      id="sub-video-wrapper"
      top={0}
      height="100%"
    >
      <Grid item padding="19px 16px"></Grid>
      <ContentWrapper container color="common.white" id="content-wrapper">
        <Grid container gap="8px" flexDirection="column">
          <Box display="flex">
            <Image src={'/hermes-static/icons/video-play-icon.svg'} width={11} alt={'play video'} />
          </Box>
          <Typography
            variant="h4"
            fontWeight={600}
            fontSize="24px"
            lineHeight="35.14px"
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: '3',
              overflow: 'hidden',
              WebkitBoxOrient: 'vertical',
              textAlign: 'start'
            }}
          >
            {title}
          </Typography>
          <Typography
            fontSize="15px"
            fontWeight={500}
            lineHeight="130%"
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: '2',
              overflow: 'hidden',
              WebkitBoxOrient: 'vertical',
              textAlign: 'start'
            }}
          >
            {practitioner}
          </Typography>
        </Grid>
      </ContentWrapper>
    </SubVideoWrapper>
  </VideoWrapper>
)

export default ReviewVideo
